import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { StatusBadge } from "./withdrawalUtils";

const requestId = (request) => request?.id || request?._id;

const resourcePersonName = (request) =>
  request?.resourcePersonName ||
  request?.resourcePerson?.name ||
  request?.name ||
  "—";

const formatDate = (date) => {
  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "--";
  return parsed.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
  });
};

const WithdrawalTable = ({ requests, isLoading, onView }) => {
  return (
    <table className="table mb-0 align-middle text-sm min-w-[760px]">
      <thead>
        <tr>
          <th className="px-2 py-2.5">Resource Person</th>
          <th className="px-2 py-2.5">Amount</th>
          <th className="px-2 py-2.5">Requested</th>
          <th className="px-2 py-2.5">Status</th>
          <th className="px-2 py-2.5">Action</th>
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          <tr>
            <td colSpan={5}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                <div className="loader"></div>
              </div>
            </td>
          </tr>
        ) : requests.length === 0 ? (
          <tr>
            <td colSpan={5}>
              <div className="d-flex justify-content-center align-items-center tableLoader">
                No withdrawal requests found
              </div>
            </td>
          </tr>
        ) : (
          requests.map((req, i) => (
            <tr key={requestId(req) || i}>
              <td className="px-2 py-2.5 font-medium">{resourcePersonName(req)}</td>
              <td className="px-2 py-2.5 font-semibold">NGN {parseFloat(req.amount || 0).toLocaleString()}</td>
              <td className="px-2 py-2.5 text-gray-500 text-xs">
                {formatDate(req.requestedAt || req.createdAt)}
              </td>
              <td className="px-2 py-2.5">
                <StatusBadge status={req.status} />
              </td>
              <td className="px-2 py-2.5">
                <button
                  onClick={() => onView(req)}
                  className="px-3 py-1.5 bg-gray-100 border border-gray-200 rounded-md cursor-pointer text-xs font-medium"
                >
                  <FontAwesomeIcon icon={faEye} className="mr-1" />
                  View
                </button>
              </td>
            </tr>
          ))
        )}
      </tbody>
    </table>
  );
};

export default WithdrawalTable;
